module.exports = __webpack_public_path__ + "static/media/useCase93x.c64630c0.png";